import script from "./ParentEsignature.vue?vue&type=script&setup=true&lang=js"
export * from "./ParentEsignature.vue?vue&type=script&setup=true&lang=js"

import "./ParentEsignature.vue?vue&type=style&index=0&id=2a265eef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2a265eef"]])

export default __exports__